import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../styles.css";

const ModalCreatorConfirm = (props) => {
    const {
        setShowConfirm,
        handleDelete,
        isShowConfirm
    } = props;

    return (
        <Modal size="md" className="alert-confirm-modal modal-size-custom" centered show={isShowConfirm} onHide={() => setShowConfirm(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Are you sure ?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-secondary">Do you really want to remove user from suggested creators? This process cannot be undone.</p>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className="alertconfirm-btns">
                        <Button
                            onClick={() => setShowConfirm(false)}
                            variant="secondary"
                            className="mr-1">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleDelete}
                            variant="danger">
                            Delete
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalCreatorConfirm;
